import VueRouter from 'vue-router';
import SignedIn from '@/components/SignedIn.vue';
import PageNotFound from '@/pages/PageNotFound.vue';
import Dashboard from '@/pages/Dashboard.vue';
import Account from '@/pages/Account.vue';
import AB from '@/pages/AB.vue';
import Help from '@/pages/Help.vue';
import Postback from '@/pages/Postback.vue';
import Offerings from '@/pages/Offerings.vue';
import ConsumptionStats from '@/pages/ConsumptionStats.vue';
import ConsumptionHeatmap from '@/pages/ConsumptionHeatmap.vue';
import CliCallback from '@/pages/CliCallback.vue';
import Demo from '@/pages/Demo.vue';
import Setup from '@/pages/Setup.vue';
import SetupApps from '@/pages/Setup/Apps.vue';
import SetupApp from '@/pages/Setup/App.vue';
import Integrations from '@/pages/Integrations.vue';
import Applications from '@/pages/Applications.vue';
import Users from '@/pages/Users.vue';
import UrlPage from '@/pages/UrlPage.vue';
import {getAdminPages, getUser} from '../api/apiServices';

var qs = require('qs');

const routes = [
    {
        path: '/signedin/',
        name: 'signedin',
        props: true,
        component: SignedIn,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/404/',
        name: '404',
        component: PageNotFound,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/account',
        name: 'account',
        component: Account,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/ab',
        name: 'ab',
        component: AB,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/help',
        name: 'help',
        component: Help,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/integrations/:type',
        name: 'Integrations type',
        component: Integrations,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/integrations',
        name: 'Integrations',
        component: Integrations,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/urls',
        name: 'urls',
        component: UrlPage,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/applications',
        name: 'Applications',
        component: Applications,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/postback',
        name: 'Postback',
        component: Postback,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/offerings',
        name: 'Offerings',
        component: Offerings,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/consumption-stats',
        name: 'ConsumptionStats',
        component: ConsumptionStats,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/consumption-heatmap',
        name: 'ConsumptionHeatmap',
        component: ConsumptionHeatmap,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
    },
    {
        path: '/demo',
        name: 'Demo',
        component: Demo,
        meta: {
            requiresAuth: false,
            isFullPage: false,
        },
    },
    {
        path: '/cli-callback',
        name: 'CliCallback',
        component: CliCallback,
        meta: {
            requiresAuth: false,
            isFullPage: true,
        },
    },
    {
        path: '/setup',
        name: 'Setup',
        component: Setup,
        meta: {
            requiresAuth: true,
            isFullPage: false,
        },
        children: [{
            path: '/',
            name: 'Setups',
            component: SetupApps,
            meta: {
                requiresAuth: true,
                isFullPage: false,
            },
        },{
            path: '/setup/:appId',
            name: 'Setup_app',
            component: SetupApp,
            meta: {
                requiresAuth: true,
                isFullPage: false,
            },
        }],
    },

];

const router = new VueRouter({
    mode: 'history',
    routes,
    // set custom query resolver
    parseQuery(query) {
        return qs.parse(query, {
            decoder(str, decoder, charset) {
                // const strWithoutPlus = str.replace(/\+/g, ' ');
                const strWithPlus = str;
                if (charset === 'iso-8859-1') {
                    // unescape never throws, no try...catch needed:
                    return strWithPlus.replace(/%[0-9a-f]{2}/gi, unescape);
                }

                // if (/^(\d+|\d*\.\d+)$/.test(str)) {
                //   return parseFloat(str)
                // }

                const keywords = {
                    true: true,
                    false: false,
                    null: null,
                    undefined,
                };
                if (str in keywords) {
                    return keywords[str];
                }

                // utf-8
                try {
                    return decodeURIComponent(strWithPlus);
                } catch (e) {
                    return strWithPlus;
                }
            },
        });
    },
    stringifyQuery(query) {
        var result = qs.stringify(query, {
            encode: false,
        });
        return result ? ('?' + result) : '';
    },
});

router.beforeEach((to, from, next) => {
    if (getAdminPages().includes(to.path) && !getUser().owner) {
        next('/dashboard');
        return;
    } else if (to.path === '/') {
        next('/dashboard');
        return;
    } else {
        next();
    }
});

export default router;
